import { APIMethod, fetchData } from "@client";
import { mapKeysToSnakeCase } from "@client/api/utils/fetchApiUtils";

export async function createRateCardTeamMemberQuery(categoryId, roleName, sortOrder) {
  const res = await fetchData(
    `/company/rate-card/roles`,
    APIMethod.POST,
    {
      isJSONData: true,
      data: mapKeysToSnakeCase({
        categoryId,
        roleName,
        sortOrder,
      })
    }
  );
  
  return res?.role;
}
